import React from 'react';
import { StyledSingleInputResponsiveWrapper } from './SingleInputResponsiveWrapper.styles';

const SingleInputResponsiveWrapper = ({ children, isModal }) => {
  return <StyledSingleInputResponsiveWrapper modal={isModal}>{children}</StyledSingleInputResponsiveWrapper>;
};

export default SingleInputResponsiveWrapper;
